// ============================================
// Nome de exibição do sensor — fonte única
// ============================================
// Três nomes concorrem, e a ordem importa:
//   display_name → o que a EMPRESA deu (PATCH /devices/:mac); vence sempre
//   label        → como o SENSOR se identifica (firmware, reescrito a cada beacon)
//   mac          → identidade crua, último recurso
// Estava repetido como `d.label || d.mac` em 8 telas. Centralizado porque a
// alternativa é uma tela mostrar o nome novo e a vizinha continuar no antigo.

export interface NameableDevice {
  mac: string
  label?: string | null
  display_name?: string | null
}

export const deviceName = (d: NameableDevice): string =>
  d.display_name || d.label || d.mac

/**
 * Segunda linha: o que AINDA NÃO está na primeira, na ordem
 * "como o sensor se identifica" → "MAC". Com apelido definido devolve
 * "RAIZ-1EE4 · 68:25:DD:37:1E:E4"; sem apelido o primário já é o RAIZ-1EE4,
 * então sobra só o MAC. null quando não sobra nada (device sem nome nenhum:
 * o primário já É o MAC e repetir seria ruído).
 *
 * A razão de existir: dar apelido não pode fazer o nome do equipamento sumir da
 * tela — quem opera precisa saber QUAL aparelho é, e quem só vê "Câmara Fria 1"
 * não consegue casar com a etiqueta física do sensor.
 */
export const deviceSubName = (d: NameableDevice): string | null => {
  const primary = deviceName(d)
  const parts = [d.label, d.mac].filter((p): p is string => !!p && p !== primary)
  return parts.length > 0 ? parts.join(' · ') : null
}
